module.exports = __webpack_public_path__ + "static/media/bn.2a6eb294.svg";